import { FormEvent, useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import { Delete } from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { useServiceDeleteStyles } from "./styles";
import { useAttendanceLocalStyles } from "../../../../../../../../../../../styles";
import { AttendanceLocalDepartmentGuicheService } from "../../../../../../../../../../../../../@types/attendance-local-department-guiche-service";
import { useAttendanceLocalDepartmentGuicheServiceDelete } from "../../../../../../../../../../../../../services/api-tansquery/attendance-local/department/guiche/service/delete";

type ServiceDeleteProps = {
    service: AttendanceLocalDepartmentGuicheService;
    buttonTrigger?: React.ReactNode;
}

export default function ServiceDelete({ service, buttonTrigger }: ServiceDeleteProps) {
    const [open, setOpen] = useState(false);
    const { classes } = useServiceDeleteStyles();
    const { classes: defaultClasses } = useAttendanceLocalStyles();
    const mutation = useAttendanceLocalDepartmentGuicheServiceDelete(service.id);

    async function handleSubmit(event: FormEvent<HTMLDivElement>) {
        event.preventDefault();

        if (mutation.isLoading) {
            return;
        }

        await mutation.mutateAsync();
    }

    useEffect(() => {
        if (mutation.isSuccess) {
            setOpen(false);
        }
    }, [mutation.isSuccess]);

    return (
        <>
            {buttonTrigger ? (
                <span onClick={() => setOpen(true)}>
                    {buttonTrigger}
                </span>
            ) : (
                <Button
                    startIcon={<Delete />}
                    className={defaultClasses.addButton}
                    onClick={() => setOpen(true)}
                >
                    Serviço
                </Button>
            )}
            <Dialog open={open} maxWidth="sm">
                <Card component="form" onSubmit={handleSubmit}>
                    <CardHeader
                        avatar={<Delete />}
                        className={classes.cardHeader}
                        title={
                            <Typography variant="h5">Serviço</Typography>
                        }
                    />
                    <CardContent className={classes.cardContent}>
                        <Typography className={classes.textWarning}>
                            Você está prestes a remover <strong>{service.servico.servico.titulo}</strong> do sistema.
                        </Typography>
                        <Typography className={classes.textWarning}>
                            Tem certeza que deseja continuar?
                        </Typography>
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button
                            className={classes.button}
                            onClick={() => setOpen(false)}
                            disabled={mutation.isLoading}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            className={classes.deleteButton}
                            disabled={mutation.isLoading}
                        >
                            {mutation.isLoading ? 'Excluindo...' : 'Excluir'}
                        </Button>
                    </CardActions>
                </Card>
            </Dialog >
        </>
    );
}
